import api from './axios';

const BASE = '/sourcers';

export const getSourcers = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const createSourcer = (data) => api.post(BASE, data);

export const updateSourcer = (id, data) => api.put(`${BASE}/${id}`, data);

export const deleteSourcer = (id) => api.delete(`${BASE}/${id}`);
